module.exports = __webpack_public_path__ + "static/media/290757.f8c40c93.png";